import { useNavigate, useLocation, useParams } from "react-router-dom";

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const match = {
      params, isExact: true, path: location.pathname, url: location.pathname, get: (search) => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get(search);
      }
    };

    const history = (to, options = {}) => {
      if (typeof to === "number") return navigate(to);

      // Handle string paths normally
      if (typeof to === "string") return navigate(to, options);

      // Handle object paths — move state to second arg
      if (typeof to === "object") {
        const { pathname, search, hash, state, replace } = to;

        // ⚡️ Key part: shift state from the first arg into options
        const finalOptions = {
          ...options,
          replace: options.replace ?? replace ?? false,
          ...(state ? { state } : {}),
        };

        // Normalize search/hash prefixes and fall back to the current pathname,
        // otherwise `navigate("search=x")` resolves as a relative route (404).
        const searchStr = search ? (search.startsWith("?") ? search : `?${search}`) : "";
        const hashStr = hash ? (hash.startsWith("#") ? hash : `#${hash}`) : "";

        const pathStr = `${pathname || location.pathname}${searchStr}${hashStr}`;
        return navigate(
          pathStr,
          finalOptions
        );
      }

      console.warn("Invalid navigation call", to, options);
    };
    history.location = location;

    return (
      <Component
        {...props}
        navigate={navigate}
        location={location}
        params={params}
        match={match}
        history={history}
      />
    );
  }

  return ComponentWithRouterProp;
}
